import React, { useState } from "react";
import { sendPasswordResetEmail } from "firebase/auth";
import { Link } from "react-router";
import { auth } from "../api/firebase";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Label } from "./ui/label";

const PasswordResetPage = () => {
  const [email, setEmail] = useState("");
  const [sent, setSent] = useState(false);
  const [error, setError] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError("");
    try {
      await sendPasswordResetEmail(auth, email);
      setSent(true);
    } catch (err: any) {
      setError(err.message || "Failed to send reset email.");
    }
  };

  if (sent) {
    return (
      <div className="max-w-md mx-auto mt-8">
        <h1 className="text-3xl font-bold my-4">Check Your Email</h1>
        <p className="mb-4">
          If an account exists for <strong>{email}</strong>, a password reset link has been sent.
        </p>
        <Link to="/login" className="text-primary hover:underline">
          Back to Login
        </Link>
      </div>
    );
  }

  return (
    <div className="max-w-md mx-auto mt-8">
      <h1 className="text-3xl font-bold my-4">Reset Password</h1>
      <form className="space-y-4" onSubmit={handleSubmit}>
        <div>
          <Label htmlFor="email">Email</Label>
          <Input
            id="email"
            type="email"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
        </div>
        {error && (
          <p className="text-sm text-red-600">{error}</p>
        )}
        <Button type="submit">Send Reset Email</Button>
      </form>
      <Link to="/login" className="text-sm text-primary hover:underline mt-4 inline-block">
        Back to Login
      </Link>
    </div>
  );
};

export default PasswordResetPage;
